// REACT IMPORTS
import React from "react";

// ICON IMPORTS
import { InfoRedCircleIcon } from "icons/subscription/InfoRedCircleIcon";

interface ServerErrorAlertProps {
  message: string | null;
  className?: string;
  "data-testid"?: string;
}

/* ------------------------------------- SERVER ERROR ALERT ------------------------------------- */

// The inline red box the login screens show when a server call fails, in the
// same style as their "Login failed" alert.
const ServerErrorAlert = ({
  message,
  className = "",
  "data-testid": testId,
}: ServerErrorAlertProps) => {
  if (!message) {
    return null;
  }

  return (
    <div
      className={`flex items-start gap-[5px] px-[10px] py-3 bg-lightRedBg rounded select-none animate__animated animate__fadeIn ${className}`}
      role="alert"
      data-testid={testId}
    >
      {/* Lined up with the first line of a message that wraps. */}
      <div className="shrink-0 pt-0.5">
        <InfoRedCircleIcon aria-hidden="true" />
      </div>
      <div className="lg:text-base text-xs text-red leading-[20.83px]">
        {message}
      </div>
    </div>
  );
};

export default ServerErrorAlert;
